type PropsFormUser = {
  currentStep: number;
  setCurrentStep: (value: number) => void;
  dataUser: any;
};

export const WelcomeSection = (props: PropsFormUser) => {

  const nextStep = () => {
    props.setCurrentStep(props.currentStep + 1);
  };

  const regex = /\b\d{1,2} [A-Za-z]+ \d{4}\b/;

  let startDate

  if (props.dataUser) {
    startDate = props.dataUser.generation?.description?.match(regex);
  }

  return (
    <section className="w-full max-w-6xl mx-auto">

      <div className="bg-white border border-gray-300 rounded-lg shadow-sm mb-6">

        <div className="p-4 sm:p-6 md:p-8 text-center border-b border-gray-300">
          <div className="flex flex-col md:flex-row items-center justify-center gap-3 mb-4">
            <h1 className="text-xl sm:text-2xl md:text-3xl font-semibold text-gray-900 text-center md:text-left">
              Te damos la bienvenida al portal de pagos de
            </h1>
            <img
              src={require('../../../assets/images/logo-azul.png')}
              alt="Desafío Latam"
              className="h-12 sm:h-16 md:h-20"
            />
          </div>
          <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
            Estás a punto de comenzar tu inscripción. Te guiaremos paso a paso para completar tu registro y configurar tu método de pago de manera segura.
          </p>
        </div>
        <div className="p-4 sm:p-6 md:p-8">
          <h2 className="text-base sm:text-lg font-semibold text-gray-900 mb-4 sm:mb-6">
            Resumen de inscripción
          </h2>

          <div className="space-y-3 sm:space-y-4">
            <div className="bg-gray-50 border border-gray-200 rounded-md p-3 sm:p-4">
              <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">Programa</p>
              <p className="text-sm sm:text-base font-semibold text-gray-900">
                  {props.dataUser?.variant_application == 1
                    ? props.dataUser?.career?.variant_friendly_name
                    : props.dataUser?.career?.friendly_name}
              </p>
            </div>

            <div className="bg-gray-50 border border-gray-200 rounded-md p-3 sm:p-4">
              <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">Fecha de inicio</p>
              <p className="text-sm sm:text-base font-semibold text-gray-900">
                {startDate || 'Por confirmar'}
              </p>
            </div>
          </div>
        </div>

        {/* Footer del card */}
        <div className="px-4 sm:px-6 md:px-8 py-4 sm:py-5 border-t border-gray-300 rounded-b-lg flex justify-end">
          <button
            className="btn w-full sm:w-auto"
            type="button"
            onClick={() => nextStep()}
          >
            Continuar
          </button>
        </div>
      </div>
    </section>
  );
};
